<div>
  <div class="row row-align">
    <h2>Informações do Veículo (Garantia do Financiamento)</h2>
  </div>

  <div>
    <div
      *ngIf="hasIdSimulacao"
      class="form-group pb0 cadastro-veiculo-info-erro"
    >
      <span
        >Não foi possível encontrar as informações sobre os veículos informados.
        Verifique, se necessário cadastre as informações manualmente.</span
      >
    </div>
    <app-ficha-cadastro-veiculo-lista
      [hasIdSimulacao]="hasIdSimulacao"
      [veiculos]="veiculos"
      [isPesados]="fichaCadastro.isPesados"
      (changeForm)="changeFormVeiculoLista($event)"
      (changeFormValid)="changeFormValidList($event)"
      [fichaCadastro]="fichaCadastro"
    >
    </app-ficha-cadastro-veiculo-lista>

    <form #formVeiculoUF="ngForm">
      <div class="row">
        <div class="marginT30 form-group tab-buttons">
          <a
            (click)="onClickPrevious()"
            *ngIf="!hasIdSimulacao"
            class="bt-back btn btn-border-orange pull-left"
          >
            <i class="fa fa-arrow-left mrBt"></i> Voltar</a
          >

          <a
            class="bt-go btn btn-full-orange pull-right"
            [ngClass]="{ disabled: !isNextAvailable }"
            (click)="onClickNext()"
            >Continuar
            <i class="fa fa-arrow-right mlBt"></i>
          </a>
        </div>
      </div>
    </form>
  </div>
</div>
